import { useIsFetching, useQueryClient } from "@tanstack/react-query";

type AppsResultsActionsState = {
    areActionsDisabled: boolean;
    isTableLoading: boolean;
    numberOfResults: number;
};

export const useAppsSearchResultsActionsState = (fetchingQueryKey: readonly unknown[]): AppsResultsActionsState => {
    const queryClient = useQueryClient();
    const numberOfFetchingQueries = useIsFetching({ queryKey: fetchingQueryKey });
    const queryState = queryClient.getQueryState<{ totalCount: number }>(fetchingQueryKey);

    const isTableLoading = numberOfFetchingQueries > 0;

    return {
        areActionsDisabled: isTableLoading,
        isTableLoading,
        numberOfResults: queryState?.data?.totalCount ?? 0,
    };
};
